export function getDecimalPlaces(number: number) {
  const numberString = number.toString()

  // 소숫점이 있는지 확인
  const decimalIndex = numberString.indexOf('.')

  if (decimalIndex === -1) {
    // 소숫점이 없으면 0을 반환
    return 0
  }
  // 소숫점 이후의 자리수를 계산하여 반환
  return numberString.length - decimalIndex - 1
}

export function getCardInfo(cardName: string, cardNumber: string) {
  const spacedCardNumber = cardNumber.replace(/(.{4})(.{4})(.{4})(.{4})/, '$1 $2 $3 $4')

  // return cardName === '알 수 없음' ? `${spacedCardNumber}` : `${cardName} | ${spacedCardNumber}`
  return `${cardName} | ${spacedCardNumber}`
}

/**
 * 숫자 뒤에 붙는 주제 조사(은/는). 숫자를 읽었을 때 마지막 소리의 받침으로 고른다.
 * 끝자리가 2(이) · 4(사) · 5(오) · 9(구)면 받침이 없어 "는", 나머지(0 영 · 1 일 · 3 삼 · 6 육 · 7 칠 · 8 팔)는 "은".
 * 끝이 0이면 십 · 백 · 천 · 만으로 끝나 모두 "은"이다 (예: 1,800은 · 0은 · 1,732는).
 */
export function numberTopicParticle(value: number | string): '은' | '는' {
  return endsWithoutFinalConsonant(value) ? '는' : '은'
}

/**
 * 숫자 뒤에 붙는 주격 조사(이/가). 규칙은 numberTopicParticle 과 같다 (예: 1,800이 · 1,732가).
 */
export function numberSubjectParticle(value: number | string): '이' | '가' {
  return endsWithoutFinalConsonant(value) ? '가' : '이'
}

function endsWithoutFinalConsonant(value: number | string): boolean {
  const digits = String(value).replace(/[^0-9]/g, '')
  const last = digits.charAt(digits.length - 1)
  return '2459'.includes(last) && last !== ''
}
